import { FormattedMessage, useIntl } from "react-intl";
import {
  IAddPatient,
  PatientDetailsFormInputs,
} from "../../../../models/users.interface";
import ConnectForm from "../../../Shared/ConnectForm/ConnectForm";
import ToggleSwitchFormInput from "../../../Shared/ToggleSwitch/ToggleSwitchFormInput";
import styles from "../AddPatientModal/AddPatientModal.module.css";

type PatientInfoInputsProps = {
  isEdit?: boolean;
  disabled?: boolean;
};
const PatientPermissionsInputs = ({ disabled }: PatientInfoInputsProps) => {
  const intl = useIntl();

  const canEmailEcgsPlaceholder = intl.messages[
    "MANAGEMENT.PATIENT_DETAILS.CAN_EMAIL_ECGS"
  ] as string;
  const canViewEcgsPlaceholder = intl.messages[
    "MANAGEMENT.PATIENT_DETAILS.CAN_VIEW_ECGS"
  ] as string;
  const ecgPreviewEnabledPlaceholder = intl.messages[
    "MANAGEMENT.PATIENT_DETAILS.ECG_PREVIEW_ENABLED"
  ] as string;

  return (
    <ConnectForm<PatientDetailsFormInputs | IAddPatient>>
      {({ control }) => {
        return (
          <>
            <p className={styles.title}>
              <FormattedMessage
                id="USER.PERMISSIONS"
                defaultMessage="Permissions"
              />
              :
            </p>
            <ul className="pl-3 m-0 list-unstyled">
              <li className="mb-2">
                <ToggleSwitchFormInput<PatientDetailsFormInputs>
                  name={"canViewEcgs"}
                  control={control}
                  input={{
                    offLabel: "",
                    onLabel: canViewEcgsPlaceholder,
                    disabled,
                  }}
                />
              </li>
              <li className="mb-2">
                <ToggleSwitchFormInput<PatientDetailsFormInputs>
                  name={"canSendEcgsViaMail"}
                  control={control}
                  input={{
                    offLabel: "",
                    onLabel: canEmailEcgsPlaceholder,
                    disabled,
                  }}
                />
              </li>
              <li className="mb-2">
                <ToggleSwitchFormInput<PatientDetailsFormInputs>
                  name={"showEcgPreview"}
                  control={control}
                  input={{
                    offLabel: "",
                    onLabel: ecgPreviewEnabledPlaceholder,
                    disabled,
                  }}
                />
              </li>
            </ul>
          </>
        );
      }}
    </ConnectForm>
  );
};
export default PatientPermissionsInputs;
